import { combineReducers } from "redux";
import { globalReducer } from "./global";
import { tierReducer } from "./tier";
import { voucherReducer } from "./voucher";
import { userReducer } from "./user";
import { bannerReducer } from "./banner";
import { warrantyReducer } from "./warranty";
import { collectPointReducer } from "./collectpoint";
import { memberReducer } from "./member";
import { memberRewardReducer } from "./memberreward";
import { catalogReducer } from "./catalog";
import { generalSettingReducer } from "./generalsetting";
import { mediaReducer } from "./media";
import { helpCenterReducer } from "./helpcenter";
import { catalogStockReducer } from "./catalogstock";
import { tenantReducer } from "./tenant";
import { logActivityReducer } from "./logactivity";
import { pointActivityReducer } from "./pointactivity";
import { redeemActivityReducer } from "./redeemactivity";
import { ocrActivityReducer } from "./ocractivity";
import { dashboardAnalyticReducer } from "./dashboardanalytic";
import { catalogEthReducer } from "./catalogeth";
import { rewardShipmentReducer } from "./rewardshipment";
import { raffleOcrActivityReducer } from "./raffleocractivity";
import { raffleReducer } from "./raffle";
import { raffleWinnerReducer } from "./rafflewinner";
import { catalogGiftReducer } from "./cataloggift";
import { raffleEventReducer } from "./raffleevent";
import { raffleMerchantReducer } from "./rafflemerchant";
import { catalogGiftDetailReducer } from "./cataloggiftdetail";
import { receiptRaffleReducer } from "./receiptraffle";
import { ultrarewardAnalyticReducer } from "./ultrarewardanalytic";
import { userComplaintReducer } from "./usercomplaint";
import { raffleAncolReducer } from "./raffleancol";
import { questReducer } from "./quest";

const reducer = combineReducers({
  globalReducer,
  questReducer,
  tierReducer,
  voucherReducer,
  userReducer,
  bannerReducer,
  warrantyReducer,
  collectPointReducer,
  memberReducer,
  memberRewardReducer,
  catalogReducer,
  generalSettingReducer,
  mediaReducer,
  helpCenterReducer,
  catalogStockReducer,
  tenantReducer,
  logActivityReducer,
  pointActivityReducer,
  redeemActivityReducer,
  ocrActivityReducer,
  dashboardAnalyticReducer,
  catalogEthReducer,
  rewardShipmentReducer,
  raffleOcrActivityReducer,
  raffleReducer,
  raffleWinnerReducer,
  catalogGiftReducer,
  raffleEventReducer,
  raffleMerchantReducer,
  catalogGiftDetailReducer,
  receiptRaffleReducer,
  ultrarewardAnalyticReducer,
  userComplaintReducer,
  raffleAncolReducer,
});

export default reducer;
